import { createContext, useContext, useEffect } from "react";

interface TitleContextType {
  title: string;
  setTitle: (title: string) => void;
}

export const TitleContext = createContext<TitleContextType>({
  title: "",
  setTitle: () => undefined,
});

export const useTitle = () => useContext(TitleContext);

export const usePageTitle = (title: string) => {
  const { setTitle } = useTitle();

  useEffect(() => {
    setTitle(title);

    // Cleanup function to reset the title when the component unmounts
    return () => setTitle("");
  }, [title, setTitle]);
};
